import { render } from "./RemnantTrust.vue?vue&type=template&id=498ea4a2&scoped=true"
import script from "./RemnantTrust.vue?vue&type=script&lang=js"
export * from "./RemnantTrust.vue?vue&type=script&lang=js"

import "./RemnantTrust.vue?vue&type=style&index=0&id=498ea4a2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498ea4a2"]])

export default __exports__